import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { ChannelsActions } from './channels.actions';

@Injectable({
  providedIn: 'root'
})
export class ChannelsEffects {
  sendChannelsEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendChannelsEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(ChannelsActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
